<template>
    <div class="components-downBtn-box">
      <div class="box-button">
            <div class="button-content">
              <div class="btn-speak" @click="toWant(1)">
                <img src="https://p2.ssl.qhimg.com/t110b9a9301659806f4d5fd3d24.png" alt="" />
                <span>我要讲</span>
              </div>
              <div class="btn-listen" @click="toWant(2)">
                <img src="https://p1.ssl.qhimg.com/t110b9a9301fe179164e636f275.png" alt="" />
                <span>我要听</span>
              </div>
          </div>
        </div>
    </div>
  </template>
  
  <script setup>
import { showToast } from 'vant'
import { ref } from 'vue'
  const props = defineProps({
  data: {
    type: Object,
    default: () => {
      return {}
    }
  }
})

const showType = ref(0)

const toWant = (type) => {
  emit('toWant', type)
}
const emit = defineEmits(['toWant'])
  </script>
  
  <style lang="scss" scoped>
  .components-downBtn-box {
    position: fixed;
    width: 100%;
    height: 80px;
    left: 0;
    // gap: 9px;
    // right: 16px;
    bottom: 0px;
    display: flex;
    align-items: center;
    background: #ffffff;
    z-index: 99;
    box-shadow: 0 -4px 10px rgba(74, 73, 73, 0.15);
    .box-button{
        width: 100%;
        display: flex;
        justify-content: center;
          .button-content{
            display: flex;
            width: 90%;
            align-items: center;
            .btn-speak{
              width: 50%;
              height: 60px;
              box-sizing: border-box;
              border-right: 1px solid rgba(255, 255, 255, 0.15);
              border-radius: 32px 0px 0px 32px;
              background: linear-gradient(180.00deg, rgb(95, 115, 164),rgb(9, 32, 88) 100%);
              display: flex;
              align-items: center;
              justify-content: center;
              img{
                width: 32px;
                height: 32px;
                margin-right: 8px;
              }
              span{
                color: rgb(255, 255, 255);
                font-family: Source Han Sans;
                font-size: 20px;
                font-weight: 700;
                line-height: 20px;
                letter-spacing: 0px;
              }
            }
            .btn-listen{
              width: 50%;
              height: 60px;
              box-sizing: border-box;
              border-left: 1px solid rgba(0, 0, 0, 0.5);
              border-radius: 0px 32px 32px 0px;
              background: linear-gradient(180.00deg, rgb(95, 115, 164),rgb(9, 32, 88) 100%);
              display: flex;
              align-items: center;
              justify-content: center;
              img{
                width: 32px;
                height: 32px;
                margin-right: 10px;
              }
              span{
                color: rgb(255, 255, 255);
                font-family: Source Han Sans;
                font-size: 20px;
                font-weight: 700;
                line-height: 20px;
                letter-spacing: 0px;
              }
            }
          }
    }
  }
  </style>
  